import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { baseUrl: String }
  static targets = ["userInput", "userResults", "thingInput", "thingResults"]

  connect() {
    console.log("🔍 SearchController connected")
  }

  _api(path) {
    const base = this.hasBaseUrlValue ? this.baseUrlValue.replace(/\/$/, "") : ""
    return `${base}${path}`
  }

  searchUsers() {
    const query = this.userInputTarget.value.trim().toLowerCase()
    if (query === "") return this.userResultsTarget.innerHTML = ""

    fetch(this._api(`/users/search?query=${encodeURIComponent(query)}`), {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    })
      .then(async (res) => {
        if (!res.ok) {
          const body = await res.text().catch(() => "")
          throw new Error(`HTTP ${res.status} ${res.statusText} ${body.slice(0, 140)}`)
        }
        const contentType = res.headers.get("content-type") || ""
        if (!contentType.includes("application/json")) {
          const body = await res.text().catch(() => "")
          throw new Error(`Non-JSON response: ${contentType || "unknown"} ${body.slice(0, 140)}`)
        }
        return res.json()
      })
      .then(data => {
        if (!Array.isArray(data)) throw new Error("Invalid user search response")

        this.userResultsTarget.innerHTML = ""

        data.forEach(user => {
          const userAlias = String(user.alias || "")

          if (
            userAlias.toLowerCase().includes(query) ||
            user.id.toString() === query
          ) {
            const result = document.createElement("div")
            result.classList.add("user-search-result")

            const aliasLink = document.createElement("a")
            aliasLink.href = this._api(`/users/${user.id}`)
            aliasLink.innerText = userAlias.toUpperCase()
            aliasLink.classList.add("smallb")
            result.appendChild(aliasLink)
            this.userResultsTarget.appendChild(result)
          }
        })
      })
      .catch(err => {
        console.error("Error during user search:", err)
        this.userResultsTarget.innerHTML = "<p>Error fetching user search results.</p>"
      })
  }

  searchThings() {
    const query = this.thingInputTarget.value.trim()
    if (query === "") return this.thingResultsTarget.innerHTML = ""

    const isTickerSearch = query.startsWith("$")
    const endpoint = isTickerSearch
      ? this._api(`/things/search_by_ticker?query=${encodeURIComponent(query.slice(1))}`)
      : this._api(`/things/search?query=${encodeURIComponent(query)}`)

    fetch(endpoint, {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    })
      .then(async (res) => {
        if (!res.ok) {
          const body = await res.text().catch(() => "")
          throw new Error(`HTTP ${res.status} ${res.statusText} ${body.slice(0, 140)}`)
        }
        const contentType = res.headers.get("content-type") || ""
        if (!contentType.includes("application/json")) {
          const body = await res.text().catch(() => "")
          throw new Error(`Non-JSON response: ${contentType || "unknown"} ${body.slice(0, 140)}`)
        }
        return res.json()
      })
      .then(data => {
        this.thingResultsTarget.innerHTML = ""

        if (!isTickerSearch) {
          data.things.forEach(thing => {
            const link = document.createElement("a")
            link.href = this._api(`/things/${thing.id}`)
            link.innerText = `THING: ${thing.title.toUpperCase()} ($${thing.ticker})`
            link.classList.add("smallb")
            this.thingResultsTarget.appendChild(link)
          })

          data.extras.forEach(extra => {
            const link = document.createElement("a")
            link.href = this._api(`/extras/${extra.id}`)
            link.innerText = `EXTRA: ${extra.title.toUpperCase()}`
            link.classList.add("smallb")
            this.thingResultsTarget.appendChild(link)
          })
        } else {
          data.things.forEach(thing => {
            const link = document.createElement("a")
            link.href = this._api(`/things/${thing.id}`)
            link.innerText = `THING: ${thing.title.toUpperCase()} ($${thing.ticker})`
            link.classList.add("smallb")
            this.thingResultsTarget.appendChild(link)
          })
        }
      })
      .catch(err => {
        console.error("Error during thing search:", err)
        this.thingResultsTarget.innerHTML = `<p>Error fetching search results: ${String(err.message || err)}</p>`
      })
  }
}
